var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value.length)?_c('ul',{staticClass:"rated list list-unstyled p-0 m-0 min-width-120"},_vm._l((_vm.maxStars),function(star){return _c('li',{key:star,staticClass:"d-inline-block star",class:{'active': star<=_vm.reviewStars}},[_c('app-icon',{staticClass:"size-14 ml-1",attrs:{"name":"star"}})],1)}),0):_c('p',{staticClass:"mb-0"},[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }